module.exports = require("@mui/icons-material/KeyboardArrowUp");